(() => {
  const targetNode = document.querySelector("cart-drawer");

  if (targetNode) {
    let debounceTimer;
    let isRendering = false;

    const observer = new MutationObserver((mutationsList) => {
      if (isRendering) return;

      for (const mutation of mutationsList) {
        if (
          mutation.type === "childList" ||
          mutation.type === "subtree" ||
          mutation.type === "attributes"
        ) {
          if (debounceTimer) clearTimeout(debounceTimer);
          
          debounceTimer = setTimeout(() => {
            isRendering = true;
            window.Abra.render();
            setTimeout(() => {
              isRendering = false;
            }, 500);
          }, 300);
          
          break;
        }
      }
    });

    observer.observe(targetNode, {
      childList: true,
      subtree: true,
      attributes: true
    });
  }
})();

// afterpay data-amount=[final.price]
(() => {
  if (!window.location.pathname.includes('/products')) return;
  
  let lastPrice = null;
  let debounceTimer;

  const updateSquarePrice = () => {
    const priceList = document.querySelector('.product-info__price price-list[data-abra-block="product"]');
    const salePriceElement = priceList?.querySelector('sale-price');
    const squareElement = document.querySelector('square-placement[data-amount]');
    
    if (salePriceElement && squareElement) {
      const clone = salePriceElement.cloneNode(true);
      clone.querySelector('.sr-only')?.remove();
      const finalPrice = parseFloat(clone.textContent.trim().replace(/[^0-9.]/g, ''));
      
      if (!isNaN(finalPrice) && finalPrice > 0 && finalPrice !== lastPrice) {
        lastPrice = finalPrice;
        squareElement.setAttribute('data-amount', finalPrice.toFixed(0));
      }
    }
  };

  const observer = new MutationObserver(() => {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(updateSquarePrice, 300);
  });

  const priceList = document.querySelector('.product-info__price price-list[data-abra-block="product"]');
  if (priceList) observer.observe(priceList, { childList: true, subtree: true });

  setTimeout(updateSquarePrice, 1000);
  setTimeout(updateSquarePrice, 2000);
})();

// videowise app product handle
(() => {
  let lastProcessed = 0;
  let slideObservers = [];
  let priceWrapperObservers = [];
  let debounceTimer = null;
  let retryTimer = null;
  let scrollRetryTimer = null;
  const isProductPage = window.location.pathname.includes('/products');
  
  const findShadowRoots = (node = document.body) => {
    const roots = [];
    const traverse = (el) => {
      if (el.shadowRoot) roots.push(el);
      if (el.children) for (let child of el.children) traverse(child);
    };
    traverse(node);
    return roots;
  };
  
  const searchProduct = (title) => {
    return fetch(`/search/suggest.json?q=${encodeURIComponent(title)}&resources[type]=product&resources[limit]=1`)
      .then(res => res.json())
      .then(data => {
        if (data.resources?.results?.products?.length > 0) {
          const product = data.resources.results.products[0];
          return fetch(`/products/${product.handle}.js`)
            .then(productRes => productRes.json())
            .then(productData => ({
              handle: productData.handle,
              variantId: productData.variants?.[0]?.id,
              url: `/products/${productData.handle}`
            }));
        }
        return null;
      })
      .catch(() => null);
  };
  
  const clearAllHandles = () => {
    const shadowHosts = findShadowRoots();
    shadowHosts.forEach(host => {
      const root = host.shadowRoot;
      const mainContent = root.querySelector('.vw-cmp__shoppable--content');
      if (mainContent) {
        mainContent.removeAttribute('product-handle');
        mainContent.removeAttribute('data-variant-id');
        const links = mainContent.querySelectorAll('a[product-handle]');
        links.forEach(link => link.remove());
        const priceWrapper = mainContent.querySelector('.price-wrapper');
        if (priceWrapper) {
          priceWrapper.removeAttribute('product-handle');
          priceWrapper.removeAttribute('data-variant-id');
          priceWrapper.removeAttribute('data-product-handle');
        }
      }
      const recommendedItems = root.querySelectorAll('.vw-cmp__shoppable-list-content-itemV2');
      recommendedItems.forEach(item => {
        item.removeAttribute('product-handle');
        item.removeAttribute('data-variant-id');
        const links = item.querySelectorAll('a[product-handle]');
        links.forEach(link => link.remove());
        const price = item.querySelector('.vw-cmp__shoppable-list-content-itemV2--price');
        if (price) {
          price.removeAttribute('product-handle');
          price.removeAttribute('data-variant-id');
          price.removeAttribute('data-product-handle');
        }
      });
    });
  };
  
  const monitorPriceWrapper = () => {
    if (!isProductPage) return;
    
    priceWrapperObservers.forEach(obs => obs.disconnect());
    priceWrapperObservers = [];
    
    const shadowHosts = findShadowRoots();
    shadowHosts.forEach(host => {
      const root = host.shadowRoot;
      const mainContent = root.querySelector('.vw-cmp__shoppable--content');
      const priceWrapper = mainContent?.querySelector('.price-wrapper');
      
      if (priceWrapper && mainContent) {
        const correctHandle = mainContent.getAttribute('product-handle');
        const correctVariantId = mainContent.getAttribute('data-variant-id');
        
        if (correctHandle) {
          const observer = new MutationObserver(() => {
            const currentHandle = priceWrapper.getAttribute('data-product-handle') || priceWrapper.getAttribute('product-handle');
            if (currentHandle !== correctHandle) {
              priceWrapper.removeAttribute('data-product-handle');
              priceWrapper.setAttribute('product-handle', correctHandle);
              priceWrapper.setAttribute('data-variant-id', correctVariantId);
            }
          });
          
          observer.observe(priceWrapper, {
            attributes: true,
            attributeFilter: ['data-product-handle', 'product-handle']
          });
          
          priceWrapperObservers.push(observer);
        }
      }
    });
  };
  
  const processDrawers = () => {
    const now = Date.now();
    if (now - lastProcessed < 2000) return;
    lastProcessed = now;
    clearAllHandles();
    setTimeout(() => {
      const shadowHosts = findShadowRoots();
      shadowHosts.forEach(host => {
        const root = host.shadowRoot;
        const drawer = root.querySelector('.vw-cmp__shoppable');
        if (drawer) {
          const style = window.getComputedStyle(drawer);
          if (style.visibility !== 'visible') return;
          
          setTimeout(() => {
            const mainContent = root.querySelector('.vw-cmp__shoppable--content');
            const mainTitle = root.querySelector('.vw-cmp__shoppable--title');
            if (mainContent && mainTitle) {
              const titleText = mainTitle.textContent.trim();
              if (!titleText) return;
              
              searchProduct(titleText).then(productData => {
                if (productData) {
                  const link = document.createElement('a');
                  link.href = productData.url;
                  link.style.display = 'none';
                  link.setAttribute('product-handle', productData.handle);
                  link.setAttribute('data-variant-id', productData.variantId);
                  mainContent.prepend(link);
                  mainContent.setAttribute('product-handle', productData.handle);
                  mainContent.setAttribute('data-variant-id', productData.variantId);
                  const priceWrapper = mainContent.querySelector('.price-wrapper');
                  if (priceWrapper) {
                    priceWrapper.removeAttribute('data-product-handle');
                    priceWrapper.setAttribute('product-handle', productData.handle);
                    priceWrapper.setAttribute('data-variant-id', productData.variantId);
                  }
                  monitorPriceWrapper();
                }
              });
            }
            const recommendedItems = root.querySelectorAll('.vw-cmp__recommended-products--grid .vw-cmp__shoppable-list-content-itemV2');
            recommendedItems.forEach(item => {
              const title = item.querySelector('.vw-cmp__shoppable-list-content-itemV2--title');
              const price = item.querySelector('.vw-cmp__shoppable-list-content-itemV2--price');
              if (title) {
                const titleText = title.textContent.trim();
                if (!titleText) return;
                
                searchProduct(titleText).then(productData => {
                  if (productData) {
                    const link = document.createElement('a');
                    link.href = productData.url;
                    link.style.display = 'none';
                    link.setAttribute('product-handle', productData.handle);
                    link.setAttribute('data-variant-id', productData.variantId);
                    item.prepend(link);
                    item.setAttribute('product-handle', productData.handle);
                    item.setAttribute('data-variant-id', productData.variantId);
                    if (price) {
                      price.removeAttribute('data-product-handle');
                      price.setAttribute('product-handle', productData.handle);
                      price.setAttribute('data-variant-id', productData.variantId);
                    }
                  }
                });
              }
            });
          }, 800);
        }
      });
    }, 300);
  };
  
  const monitorSlides = () => {
    slideObservers.forEach(obs => obs.disconnect());
    slideObservers = [];
    
    const shadowHosts = findShadowRoots();
    shadowHosts.forEach(host => {
      const root = host.shadowRoot;
      const slides = root.querySelectorAll('.vw-cmp__keen-player-slide');
      
      slides.forEach(slide => {
        const observer = new MutationObserver(() => {
          clearAllHandles();
          
          if (debounceTimer) clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => {
            lastProcessed = 0;
            processDrawers();
          }, 1000);
          
          if (scrollRetryTimer) clearTimeout(scrollRetryTimer);
          scrollRetryTimer = setTimeout(() => {
            lastProcessed = 0;
            processDrawers();
          }, 1500);
        });
        
        observer.observe(slide, {
          attributes: true,
          attributeFilter: ['style']
        });
        
        slideObservers.push(observer);
      });
    });
  };
  
  const checkModalVisibility = () => {
    const shadowHosts = findShadowRoots();
    let isVisible = false;
    shadowHosts.forEach(host => {
      const root = host.shadowRoot;
      const drawer = root.querySelector('.vw-cmp__shoppable');
      if (drawer) {
        const style = window.getComputedStyle(drawer);
        if (style.visibility === 'visible') {
          isVisible = true;
        }
      }
    });
    return isVisible;
  };
  
  let wasVisible = false;
  const observer = new MutationObserver(() => {
    const isVisible = checkModalVisibility();
    if (isVisible && !wasVisible) {
      lastProcessed = 0;
      const initialDelay = isProductPage ? 2500 : 800;
      setTimeout(() => {
        processDrawers();
        monitorSlides();
      }, initialDelay);
      
      if (retryTimer) clearTimeout(retryTimer);
      const retryDelay = isProductPage ? 5000 : 4000;
      retryTimer = setTimeout(() => {
        lastProcessed = 0;
        processDrawers();
      }, retryDelay);
    } else if (!isVisible && wasVisible) {
      clearAllHandles();
      lastProcessed = 0;
      slideObservers.forEach(obs => obs.disconnect());
      slideObservers = [];
      priceWrapperObservers.forEach(obs => obs.disconnect());
      priceWrapperObservers = [];
      if (debounceTimer) clearTimeout(debounceTimer);
      if (retryTimer) clearTimeout(retryTimer);
      if (scrollRetryTimer) clearTimeout(scrollRetryTimer);
    }
    wasVisible = isVisible;
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });
  
  document.addEventListener('click', (e) => {
    if (e.target.closest('.vw-cmp__in-video-card--root')) {
      const clickDelay = isProductPage ? 2500 : 1500;
      setTimeout(() => {
        lastProcessed = 0;
        processDrawers();
        monitorSlides();
      }, clickDelay);
    }
  });
})();